import React from 'react';
import { View, Text } from '@react-pdf/renderer';
import { type, colors, space } from '../theme';
import WarningGlyph from '../components/WarningGlyph';

// Matches the in-app coaching banner shown when Murphy graded a Live Meeting
// red and the company "Who We Are" pitch wasn't delivered. Reuses the visual
// language of the on-screen banner so the PDF feels familiar.
const WhoWeAreBannerSection = ({ report }) => {
  const review = report.murphyReview;
  if (!review || review.status !== 'not-delivered') return null;

  return (
    <View wrap={false} style={{
      flexDirection: 'row',
      backgroundColor: colors.dangerBg,
      borderLeftWidth: 4,
      borderLeftColor: colors.danger,
      borderRadius: 6,
      paddingVertical: space.md,
      paddingHorizontal: space.lg,
      alignItems: 'flex-start',
    }}>
      <View style={{ marginRight: space.md, marginTop: 2 }}>
        <WarningGlyph size={16} color={colors.danger} />
      </View>
      <View style={{ flex: 1 }}>
        <Text style={[type.cardTitle, { color: colors.danger }]}>
          Deliver the "Who We Are" pitch to this prospect
        </Text>
        <Text style={[type.body, { color: colors.inkSoft, marginTop: 4 }]}>
          Red grade — the core company message wasn't fully delivered on this call.
          Sharpen the Casual Encounter pitch in Training Hub, then bring it to your next
          conversation with this prospect.
        </Text>
      </View>
    </View>
  );
};

export default WhoWeAreBannerSection;
